<template>
    <modal ref="cartModal" :name="product.name">
        <template v-slot:default>
            <form>
                <cart-field v-for="(field, index) in product.fields" :key="field.name" :field="field"
                    v-model="data_real.information[field.name]"></cart-field>
            </form>
        </template>
        <template v-slot:footer>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
            <button type="submit" class="btn btn-primary" @click.prevent="saveToCart">加入購物車</button>
        </template>
    </modal>
</template>
<script>
    import axios from 'axios';
    import translator from '../../library/data-translator';
    import eventHub from '../../library/eventHub';

    export default {
        props: {
            product: {
                required: true
            }
        },
        data() {
            return {
                data_template: {
                    product_id: null,
                    quantity: 1,
                    information: {}
                },
                data_real: {}
            };
        },
        watch: {
            product: {
                deep: true,
                handler(newProduct, oldProduct) {
                    this.data_template.product_id = newProduct.id;
                    this.data_real.product_id = newProduct.id;
                    this.initData();
                }
            }
        },
        mounted() {
            this.product_id = this.product.id;
        },
        methods: {
            initData() {
                this.product.fields.forEach(field => {
                    if (field.type === 'checkbox')
                        this.data_template.information[field.name] = [];
                    else
                        this.data_template.information[field.name] = null;
                });
                this.data_real = translator.cloneVariable(this.data_template, true);
            },
            modalShow() {
                this.$refs.cartModal.modalShow();
            },
            saveToCart() {
                axios.post(`${base_url}/api/cart/add`, this.data_real)
                    .then((...response_success) => {
                        // console.log(response_success);
                        let response_data = response_success[0].data;
                        eventHub.$emit('cart:update', response_data);
                        this.$refs.cartModal.modalHide();
                        this.initData();
                        return;
                    })
                    .catch((...response_error) => {
                        console.log(response_error);
                        return;
                    });

            }
        }
    }
</script>
<style lang="">

</style>